import helper from 'Resources/util/helper';

const rule = {
  cod_fee: (min, max) => {
    return {
      presence: {
        allowEmpty: false,
        message: "^emptyErrorMessage",
      },
      numericality: {
        notGreaterThanOrEqualTo: {
          lang: "notGreaterThanOrEqualToInvalidErrorMessage",
          value: helper.currencyFormat(min),
          suffix: "not_greater_than_or_equal_to_suffix",
        },
        greaterThanOrEqualTo: min,
        lessThanOrEqualTo: max,
        notLessThanOrEqualTo: {
          lang: "notLessThanOrEqualToInvalidErrorMessage",
          value: helper.currencyFormat(max),
          suffix: "not_less_than_or_equal_to_suffix",
        },
      },
    };
  },
  weight: (min, max) => {
    return {
      presence: {
        allowEmpty: false,
        message: "^emptyErrorMessage",
      },
      numericality: {
        notGreaterThanOrEqualTo: {
          lang: "notGreaterThanOrEqualToInvalidErrorMessage",
          value: min,
          suffix: "not_greater_than_or_equal_to_suffix",
        },
        greaterThanOrEqualTo: min,
        lessThanOrEqualTo: max,
        notLessThanOrEqualTo: {
          lang: "notLessThanOrEqualToInvalidErrorMessage",
          value: max,
          suffix: "not_less_than_or_equal_to_suffix",
        },
      },
    };
  },
  length: {
    presence: {
      allowEmpty: false,
      message: "^emptyErrorMessage",
    },
    length: {
      is: 6,
      message: "^lengthMustBeSpecificLengthErrorMessage6",
    },
  },
  between_length: (min, max) => {
    return {
      presence: {
        allowEmpty: false,
        message: "^emptyErrorMessage",
      },
      length: {
        minimum: min,
        maximum: max,
        tooShort: {
          lang: "lengthNotGreaterThanOrEqualToInvalidErrorMessage",
          value: min,
          suffix: "length_not_greater_than_or_equal_to_suffix",
        },
        tooLong: {
          lang: "lengthNotLessThanOrEqualToInvalidErrorMessage",
          value: max,
          suffix: "length_not_less_than_or_equal_to_suffix",
        }
      },
    };
  },
};

export default { rule };
